import { AlertTriangle as AlertTriangleIcon } from 'lucide-react';

const ErrorMessage = () => {
    return (
        <div className="w-full flex items-start gap-3 bg-danger-100 border border-danger-300 text-danger-700 rounded-xl p-4 shadow-sm">
            <AlertTriangleIcon className="h-6 w-6 text-danger-500 mt-0.5" />
            <div>
                <p className="text-sm">
                    An unexpected error occurred. Please{' '}
                    <a
                        href="mailto:support@avanser.com"
                        className="underline font-medium hover:text-danger-600"
                    >
                        contact support
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};

export default ErrorMessage;
